import React from 'react'
import NewsletterForm from './NewsletterForm'

const NewsletterPanel = props => (
  <div className="box is-shadowless">
    <p className="title is-4 has-text-centered has-text-primary">join the newsletter</p>
    <p className="subtitle is-7 has-text-centered">or don't, what do we care? but if you do, we promise to send cool stuff</p>
    <NewsletterForm />
  </div>
)

export default NewsletterPanel



// WEBPACK FOOTER //
// ./src/components/NewsletterPanel.jsx